<template>
    <div class="change-pwd-page p-3">
        <b-row>
            <b-col md="6" offset-md="3">
                <b-card class="shadow-sm border-0 rounded-lg">
                    <template #header>
                        <h5 class="mb-0 text-primary font-weight-bold">
                            <b-icon icon="key-fill" class="mr-2"></b-icon>
                            ປ່ຽນລະຫັດຜ່ານ
                        </h5>
                    </template>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group label="ລະຫັດຜ່ານເກົ່າ:">
                            <b-form-input type="password" v-model="old_password" required></b-form-input>
                        </b-form-group>

                        <b-form-group label="ລະຫັດຜ່ານໃໝ່:">
                            <b-form-input type="password" v-model="new_password" required minlength="6"></b-form-input>
                        </b-form-group>

                        <b-form-group label="ຢືນຢັນລະຫັດຜ່ານໃໝ່:">
                            <b-form-input type="password" v-model="confirm_password" required minlength="6"></b-form-input>
                        </b-form-group>

                        <b-alert :show="error != ''" variant="danger">{{ error }}</b-alert>

                        <b-button type="submit" variant="primary" block :disabled="submitting" class="rounded-pill font-weight-bold">
                            <b-icon icon="check-circle" class="mr-1"></b-icon> ບັນທຶກ
                        </b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            user: [],
            old_password: '',
            new_password: '',
            confirm_password: '',
            error: '',
            submitting: false,
        }
    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
    },
    methods: {
        onSubmit() {
            this.error = ''

            if (this.new_password !== this.confirm_password) {
                this.error = 'ລະຫັດຜ່ານໃໝ່ ແລະ ການຢືນຢັນລະຫັດຜ່ານບໍ່ກົງກັນ.'
                return
            }
            if (this.new_password.length < 6) {
                this.error = 'ລະຫັດຜ່ານໃໝ່ຕ້ອງມີຢ່າງໜ້ອຍ 6 ຕົວອັກສອນ.'
                return
            }

            this.submitting = true
            axios.post(
                this.$store.getters.getBaseUrl + '/changepwd',
                {
                    old_password: this.old_password,
                    new_password: this.new_password,
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
                .then((res) => {
                    this.submitting = false
                    if (res.data.code == 1) {
                        this.old_password = ''
                        this.new_password = ''
                        this.confirm_password = ''
                        this.$bvToast.toast(res.data.desc, {
                            title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: true
                        })
                    } else {
                        this.error = res.data.desc
                    }
                })
                .catch((e) => {
                    this.submitting = false
                    this.error = 'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບໄດ້, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.'
                    console.log(e)
                })
        }
    }
}
</script>

<style scoped>
.change-pwd-page {
    background-color: #f4f7f6;
    min-height: 100vh;
}
.rounded-lg {
    border-radius: 12px !important;
}
</style>
